import { Pipe, PipeTransform } from '@angular/core';

  @Pipe({
      name: 'replace'
  })
  export class ReplaceStringPipe implements PipeTransform {
      transform(value: string, oldValue: string, newValue: string): string {
          return value.replace(oldValue, newValue);
      }
}

@Pipe({
    name: 'localebykey'
})
export class LocaleByKeyPipe implements PipeTransform {
    transform(items: Array<any>, key: string, view : string): string {
        let localeMatches = items.filter(item => {
            return item.key === key && (item.view == null || item.view == undefined || item.view === view);
        });

        if (localeMatches.length > 0) {
            return localeMatches[0].value;            
        } else {
            return "";
        }
    }
}